import React from "react";
import getConfig from "next/config";
import Link from "next/link";
import { resizeImage } from "@lib/helpers";
import Heading from "@components/Heading";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const PromoHomepageCategories = ({ campaign, tree }) => {
  if (tree && tree.length > 0) {
    return (
      <ul className="flex flex-wrap -mx-1 md:-mx-2 py-6">
        {tree.map((subcategory) => (
          <li
            className="w-1/2 md:w-1/3 lg:w-1/5 p-1 md:p-2"
            key={subcategory.id}
          >
            <Link
              href={`${settings.baseUrl}/promo/${campaign.slug}/${subcategory.slug}/`}
            >
              <a className="border-gray-1100 bg-white border rounded-tr-lg rounded-bl-lg min-h-260px lg:min-h-320px flex flex-col h-full p-4 text-center hover:shadow-mixRedYellow">
                {subcategory?.properties?.icon_image && (
                  <img
                    src={resizeImage(
                      subcategory.properties.icon_image,
                      "300x300"
                    )}
                    className="flex-none w-90px h-90px md:w-120px md:h-120px mx-auto mt-10"
                    alt=""
                  />
                )}
                <Heading
                  as="h2"
                  display="h4"
                  title={subcategory.name}
                  classesProp="break-words mt-5 text-[22px] leading-20 -tracking-0.36"
                />
              </a>
            </Link>
          </li>
        ))}
      </ul>
    );
  }

  return null;
};

export default PromoHomepageCategories;
